// $(document).ready(function () {
//   function mainProductQuantityProcess () {
//     const quantityInput = $(this).parent().find('.product-card__quantity-input')
//     const quantity = Number(quantityInput.val())
//     const maxQuantity = Number(quantityInput.attr('max'))
//     if ($(this).hasClass('product-card__quantity-btn--plus')) {
//       if(quantity === 1) {
//         $('.product-card__quantity-btn--minus').removeClass('disabled')
//       }
//       const newQuantity = quantity + 1
//       if (newQuantity === maxQuantity) {
//         $(this).addClass('disabled')
//       }
//       quantityInput.attr('value', newQuantity)
//     }else if ($(this).hasClass('product-card__quantity-btn--minus')) {
//       const newQuantity = quantity - 1
//       if (newQuantity === 1) {
//         $(this).addClass('disabled')
//       }
//       quantityInput.attr('value', newQuantity)
//     }
//   }

//   $('.product-card__quantity-btn').on('click', mainProductQuantityProcess)
//   $(document).on('recommendedUpdate',function () {
//     $('.product-card__quantity-btn').off('click', mainProductQuantityProcess).on('click', mainProductQuantityProcess)
//   })
// })

$(document).ready(function () {
  function updateButtonStates(quantityInput) {
    const quantity = Number(quantityInput.val());
    const maxQuantity = Number(quantityInput.attr('max'));
    
    const minusButton = quantityInput.parents().find('.product-card__quantity-btn--minus');
    const plusButton = quantityInput.parents().find('.product-card__quantity-btn--plus');
    
    if (quantity <= 1) {
      minusButton.addClass('disabled');
    } else {
      minusButton.removeClass('disabled');
    }
    
    if (quantity >= maxQuantity) {
      plusButton.addClass('disabled');
    } else {
      plusButton.removeClass('disabled');
    }
  }

  function mainProductQuantityProcess() {
    const quantityInput = $(this).parent().find('.product-card__quantity-input');
    const quantity = Number(quantityInput.val());
    
    if ($(this).hasClass('product-card__quantity-btn--plus')) {
      const newQuantity = quantity + 1;
      quantityInput.val(newQuantity);
    } else if ($(this).hasClass('product-card__quantity-btn--minus')) {
      if (quantity > 1) {
        const newQuantity = quantity - 1;
        quantityInput.val(newQuantity);
      }
    }
    
    updateButtonStates(quantityInput);
  }
  $(document).on('input', '.product-card__quantity-input', function() {
    const quantityInput = $(this);
    updateButtonStates(quantityInput);
  });
  $(document).on('click', '.product-card__quantity-btn', mainProductQuantityProcess);
  $(document).on('recommendedUpdate', function () {
    $(document).off('click', '.product-card__quantity-btn', mainProductQuantityProcess).on('click', '.product-card__quantity-btn', mainProductQuantityProcess);
  });
});